import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { normalizeLanguage } from './supported-language';

@Injectable({ providedIn: 'root' })
export class CustomTranslateLoader extends TranslateLoader {
  constructor(private http: HttpClient) {
    super();
  }

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    const language = normalizeLanguage(lang) || 'ru';
    return this.http.get<Record<string, unknown>>(`../assets/translates/${language}.json`);
  }
}
